import { render, staticRenderFns } from "./AddCustomer.vue?vue&type=template&id=180b5492&"
import script from "./AddCustomer.vue?vue&type=script&lang=js&"
export * from "./AddCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomer.vue?vue&type=style&index=0&id=180b5492&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports